<template>
  <div
    class="relative flex items-center justify-center w-full bg-section-system bg-no-repeat bg-cover overflow-hidden p-14"
  >
    <div class="flex items-center justify-center w-full flex-wrap">
      <a
        class="font-bold flex items-center justify-center w-full max-w-md h-66 rounded-md text-white uppercase bg-opacity-75 bg-gray-900 text-2.2 border-2 border-soft-violet mx-8 hover:bg-vivid-pink hover:border-white hover:text-black"
        v-for="(link, index) in eventData"
        :key="index"
        v-html="link.title"
        :href="link.href"
        target="_blank"
      ></a>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      eventData: [
        {
          title: 'patch notes',
          href:
            'https://latale.papayaplay.com/latale.do?tp=news.view&postid=3490',
        },
        {
          title: 'events',
          href:
            'https://latale.papayaplay.com/latale.do?tp=news.view&postid=3488',
        },
        {
          title: 'sales',
          href:
            'https://latale.papayaplay.com/latale.do?tp=news.view&postid=3489',
        },
      ],
    };
  },
};
</script>

<style></style>
